type ListStatus = 'INIT' | 'PENDING' | 'SUCCESS' | 'ERROR' | 'REFRESH';

export function makeFetchGate() {
  let latestKey: string | null = null;
  let generation = 0;

  return {
    begin(requestKey: string, status: ListStatus) {
      if ((status === 'PENDING' || status === 'REFRESH') && requestKey === latestKey) {
        return { skip: true as const };
      }
      const sameQuery = requestKey === latestKey;
      latestKey = requestKey;
      const gen = ++generation;
      const nextStatus: 'PENDING' | 'REFRESH' =
        sameQuery && (status === 'SUCCESS' || status === 'REFRESH') ? 'REFRESH' : 'PENDING';
      return { skip: false as const, generation: gen, nextStatus };
    },
    isCurrent(gen: number) {
      return gen === generation;
    },
  };
}
